import { styled } from 'styled-components'

import { UnstyledButton } from '@b-stock/fe-core/bstock-next/components'
import { Colors } from '@b-stock/fe-core/design-system'

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.85);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100;
`

export const Dialog = styled.div`
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 101;

  &:focus {
    outline: none;
  }
`

export const Header = styled.div`
  align-items: center;
  color: ${Colors.Semantic.Neutral.white};
  display: flex;
  flex-shrink: 0;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem 1.5rem;
`

export const Title = styled.span`
  font-size: 0.9375rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const CircleButton = styled(UnstyledButton)`
  align-items: center;
  background: rgba(128, 128, 128, 0.3);
  border: 0.0625rem solid rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  color: ${Colors.Semantic.Neutral.white};
  display: flex;
  flex-shrink: 0;
  font-size: 1.25rem;
  height: 3rem;
  justify-content: center;
  transition: background 0.15s;
  width: 3rem;

  &:hover {
    background: rgba(128, 128, 128, 0.5);
    border-color: rgba(255, 255, 255, 0.3);
  }
`

export const CloseButton = styled(CircleButton)``

export const GridToggleButton = styled(CircleButton)``

export const DownloadButton = styled(CircleButton)``

export const HeaderActions = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
`

export const ImageArea = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  min-height: 0;
  position: relative;
`

export const ImageWrapper = styled.div`
  background: #2a2a2a;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 1rem;
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.6);
  height: min(680px, 78vh);
  max-height: 100%;
  max-width: calc(100vw - 3rem);
  position: relative;
  width: min(1100px, 88vw);
`

const NavButton = styled(CircleButton)`
  margin: 0 1rem;
  position: absolute;
  z-index: 1;
`

export const NavButtonLeft = styled(NavButton)`
  left: 0;
`

export const NavButtonRight = styled(NavButton)`
  right: 0;
`

export const Footer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 0.5rem;
  padding: 1rem;
`

export const Counter = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8125rem;
`
